import { useObrasDateFilter } from "./use-obras-date-filter";
import { ObrasDateFilterView } from "./view-obras-date-filter";
import type { ObrasDateFilterProps } from "./types-obras-date-filter";

export function ObrasDateFilter(props: ObrasDateFilterProps) {
  const vm = useObrasDateFilter(props);

  return <ObrasDateFilterView {...vm} />;
}

export type * from "./types-obras-date-filter";
